function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M155.88,979.23Q199.55,953,257.44,953a184.16,184.16,0,0,1,84.32,20.23q40,20.25,69.77,57.53l47.23-39.42A272.85,272.85,0,0,0,397.33,935q-34.08-22.56-68.71-32.5a256.92,256.92,0,0,0-71.18-9.94q-48.66,0-90.21,13.49T95.16,943.72A239.89,239.89,0,0,0,43,1000.9a248.38,248.38,0,0,0-32.32,73,325.1,325.1,0,0,0-10.64,84q0,49.35,13.3,91.61t37.11,73a238.6,238.6,0,0,0,56.1,52.38,242.31,242.31,0,0,0,70.67,32.31,298.55,298.55,0,0,0,80.26,10.64q64.62,0,114.86-26.27a270.73,270.73,0,0,0,86.46-71.37l-47.23-39.77Q349,1357.4,257.44,1357.4a211.06,211.06,0,0,1-61.8-8.88,176,176,0,0,1-52.74-26.1,182.36,182.36,0,0,1-40.82-41.19q-17.2-24-26.62-55.57A236.37,236.37,0,0,1,66,1157.84q0-59.65,23.1-106t66.76-72.62"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 526.36,
  y: 904.43,
  width: 58.58,
  height: 509.43
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M738.42,916.92a41.34,41.34,0,0,0-20.95-5.52q-17.76,0-29.82,12.09a41.57,41.57,0,0,0,0,58.58q12.09,12.09,29.82,12.07a40.67,40.67,0,0,0,29.66-12.07A39.42,39.42,0,0,0,759.38,953,40.38,40.38,0,0,0,753.69,932a41.32,41.32,0,0,0-15.27-15.09"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 687.65,
  y: 1059.84,
  width: 58.58,
  height: 354.02
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M1267.35,1055.58q-40.14,0-73.68,17.92t-55.23,51H1137q-27.69-68.88-111.86-68.88a137,137,0,0,0-66,16.86q-31.26,16.88-52.91,47.75h-1.07v-60.35H846.57v354h58.59V1238.09q0-58.58,29.11-93.57t73.51-35q28.07,0,46.53,11.55t28,36.74q9.62,25.2,9.59,63.92v192.1h58.59V1238.09q0-58.24,28.41-93.39t71-35.15q42.61,0,62.67,27t20.05,85.92v191.41h58.6V1206.48q0-77-31.25-114t-92.67-36.92"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M1751.09,1290.46q-9.58,23.63-25.92,39.77a118.54,118.54,0,0,1-38,25.22,116.71,116.71,0,0,1-45.45,9q-53.27,0-86.28-35.33t-33-89.66q0-58.24,34.27-94.1t85.76-35.86a110.72,110.72,0,0,1,46.86,10.11,114.08,114.08,0,0,1,37.64,27.53,129.81,129.81,0,0,1,24.68,41.36,143.19,143.19,0,0,1,9.06,51,134.18,134.18,0,0,1-9.59,51m7.45-178.07h-1.41a145.83,145.83,0,0,0-53.44-42.26q-31.44-14.55-68-14.55-49.32,0-89.11,24t-62,65.87q-22.21,41.89-22.19,93.75,0,39.77,13.49,73.5t36.76,56.82a166.28,166.28,0,0,0,55.21,36,179.83,179.83,0,0,0,68.17,13q38.71,0,70.48-16a150.86,150.86,0,0,0,53.44-44.74H1761v56.11h56.45v-354h-59Z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M2178.62,1290.46q-9.57,23.63-25.74,39.77a117.08,117.08,0,0,1-37.64,25.22,113.79,113.79,0,0,1-44.56,9q-53.25,0-86.3-35.33t-33-89.66q0-58.24,34.27-94.1t85.75-35.86a107.57,107.57,0,0,1,46.16,10.11,113.13,113.13,0,0,1,37.12,27.53,131.62,131.62,0,0,1,24.49,41.36,143.19,143.19,0,0,1,9,51,134,134,0,0,1-9.58,51m7.45-178.07H2185a147.62,147.62,0,0,0-33.56-31.25,145.63,145.63,0,0,0-41-19.17,163.11,163.11,0,0,0-45.8-6.39,172.09,172.09,0,0,0-69.26,14q-32.31,14-55,38.35t-35.87,58.41a200.61,200.61,0,0,0-13.13,72.8q0,39.77,13.48,73.5t36.77,56.82a166.28,166.28,0,0,0,55.21,36,179.84,179.84,0,0,0,68.18,13,159.55,159.55,0,0,0,48.47-7.28,143,143,0,0,0,41.36-20.78,152.87,152.87,0,0,0,32.67-32.67h1.07v56.11H2245V904.43h-58.94Z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M2394.22,916.92a41.44,41.44,0,0,0-21-5.52q-17.74,0-29.82,12.09a41.55,41.55,0,0,0,0,58.58q12.06,12.09,29.82,12.07a40.71,40.71,0,0,0,29.67-12.07A39.42,39.42,0,0,0,2415.17,953a40.29,40.29,0,0,0-5.7-20.94,41.56,41.56,0,0,0-15.25-15.09"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M2343.43,1451.14q0,29.11-12.62,43.33t-33.53,14.2A69,69,0,0,1,2260.7,1498l-9.6,52.2q27.69,12.07,61.08,12.07,41.9,0,66.05-29.65t24.15-81.49v-391.3h-59Z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M2742,1231.35q0,30.51-8.51,56.09t-22.9,42.09a102.35,102.35,0,0,1-33.39,25.55,92.43,92.43,0,0,1-40.29,9.06q-43.66,0-65-25.74t-21.31-84.69V1059.84h-58.94v210.91q0,73.89,35,110.79t97.82,36.94a135.84,135.84,0,0,0,65-16.34q30.54-16.34,51.48-46.87H2742v58.59h59v-354h-59Z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M3077.36,1233.83q-11.71-5.68-68.53-27.7-16.7-6.41-27-11.19a150.64,150.64,0,0,1-20.41-11.54c-6.77-4.5-11.72-9.47-14.91-14.91a35.1,35.1,0,0,1-4.81-18.11q0-18.47,16.51-30t37.82-11.56q51.49,0,94.1,36.93l30.55-46.52q-53.31-43.66-121.81-43.66-50.41,0-83.8,27.15t-33.38,67.65a97.21,97.21,0,0,0,5.87,34.44,89.53,89.53,0,0,0,14.74,26.27q8.86,10.68,23.77,20.07a221.38,221.38,0,0,0,28.58,15.45q13.7,6,33.58,12.78c1.88.71,4.73,1.66,8.51,2.84,7.57,2.84,13.21,4.91,16.87,6.22s8.46,3.07,14.37,5.33a134.07,134.07,0,0,1,13.32,5.68q4.46,2.28,10.67,5.87a39.47,39.47,0,0,1,9.05,6.56c1.89,2,3.9,4.37,6,7.11a21.62,21.62,0,0,1,4.25,8.69,44.11,44.11,0,0,1,1.06,9.94q0,20.23-18.1,33.73t-49,13.49q-35.14,0-60.54-10.65T2897,1322.6l-30.55,44.74q57.54,51.14,138.84,51.14,30.89,0,55.59-8t40.11-22a94.49,94.49,0,0,0,23.45-32.32,96.81,96.81,0,0,0,8-39.23q0-22.38-7.11-38.71-11.37-26.26-47.93-44.38"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M3384.63,1345q-31.59,18.1-59.66,18.11-24.12,0-33.72-15.09t-9.6-48.48V1111h117.19v-51.12H3281.65v-87.7h-58.93v87.7H3164.6V1111h58.12v197.43q0,110.08,92,110.09a188.43,188.43,0,0,0,36.59-3.38q17-3.36,27.34-7.81a238.45,238.45,0,0,0,21.66-10.82Z"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M1987.83,471.67a29.89,29.89,0,1,1-29.9,29.89,29.88,29.88,0,0,1,29.9-29.89m0,118.4a88.4,88.4,0,0,0,83.37-59h182.17v-59H2071.2a88.39,88.39,0,0,0-166.74,0H1191.24v59h713.22a88.41,88.41,0,0,0,83.37,59"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M1722.7,295a29.83,29.83,0,1,1-29.89,29.9A29.89,29.89,0,0,1,1722.7,295m-.4,118a88.4,88.4,0,0,0,83.37-59h329.69V295H1805.67a88.4,88.4,0,0,0-166.73,0H1384.26a117.74,117.74,0,0,1,162-42.62c-.53-5.37-.93-10.88-.93-16.38a174.54,174.54,0,0,1,6.43-46.42,176.74,176.74,0,0,1,331.09-27.93l46.69-38.95A236.07,236.07,0,0,0,1722.3,0c-110,0-202.19,75.4-228.43,177.42-2.48-.13-5-.4-7.59-.4-77,0-142.4,49.3-166.66,118a176,176,0,0,0-10.37,59h329.69a88.39,88.39,0,0,0,83.36,59"
});

var SvgClimadjustLsWhite = function SvgClimadjustLsWhite(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    viewBox: "0 0 3400.26 1562.28",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClimadjustLsWhite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Climadjust_LS-WHITE.c4840310.svg";
export { ForwardRef as ReactComponent };